const OpcUaServerStatus = {
  INITIALIZING: "initializing",
  ACTIVE: "active",
  FAILURE: "failure",
};

export default OpcUaServerStatus;
